import exampleTexts from './exampleTranslationTexts-engb.json';

export const translations = {
  [exampleTexts.language]: exampleTexts,
};

export type translationsType = typeof exampleTexts.translations;
